"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ProductVideo = /** @class */ (function (_super) {
    __extends(ProductVideo, _super);
    function ProductVideo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    ProductVideo.prototype.render = function () {
        return (React.createElement("div", { className: "w-full " + (this.props.className ? this.props.className : "block") },
            React.createElement("div", { className: "container mx-auto block text-center" },
                React.createElement("iframe", { className: "w-full h-18 md:h-32", src: this.props.content.video, frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))));
    };
    return ProductVideo;
}(React.PureComponent));
exports.ProductVideo = ProductVideo;
